module.exports = {
    api: 'https://app-sandbox.formulir.com/api/',
    isDev: false,
    baseUrl: 'https://sandbox.form.id',
    googleCaptchaKey: '8133ec97-b0eb-43fe-bbc4-710ea27745c5',
    redirectUrl: 'https://sandbox.form.id/',
    imagekit:{
        thumbnail:"https://media.form.id/gcs/tr:n-ik_thumbnail",
        medium: "https://media.form.id/gcs/tr:n-ik_medium",
        full:"https://media.form.id/gcs/tr:n-ik_full/",      
    },
    shippingUrl:"https://app.mengantar.com/api/",
    orderHmacSecret: "formulir2021"
}
